import {
  createComponent,
  createElement,
  createHook
} from "./CFEUKV6C.js";
import {
  __spreadProps,
  __spreadValues
} from "./PNRLI7OV.js";

// src/visually-hidden/visually-hidden.ts
var useVisuallyHidden = createHook((props) => {
  props = __spreadProps(__spreadValues({}, props), {
    style: __spreadValues({
      border: 0,
      clip: "rect(0 0 0 0)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      whiteSpace: "nowrap",
      width: "1px"
    }, props.style)
  });
  return props;
});
var VisuallyHidden = createComponent(
  (props) => {
    const htmlProps = useVisuallyHidden(props);
    return createElement("span", htmlProps);
  }
);
if (process.env.NODE_ENV !== "production") {
  VisuallyHidden.displayName = "VisuallyHidden";
}

export {
  useVisuallyHidden,
  VisuallyHidden
};
